// @ts-nocheck
import { RECENT_LIST_ERROR, RECENT_LIST_LOADING, RECENT_LIST_SUCCESS} from "../../Action/Type";

const initialState = {
    payload: {},
    loading: false,
    error: ''
}

export const RecentListReducer = (state = initialState, action) => {
    switch (action.type) {
        case RECENT_LIST_LOADING:
            return Object.assign({}, state, { loading: true })
        case RECENT_LIST_SUCCESS:
            return Object.assign({}, state, { payload: action.data, loading: false })
        case RECENT_LIST_ERROR:
            return Object.assign({}, state, { payload: action.data, loading: false })
        default:
            return state
    }
}

